module.exports = __webpack_public_path__ + "static/media/plus.0e86fcf0.svg";